import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  enable(event) {
    this.sendEvent("enableCustomTheme", {checked: event.target.checked});
  }

  update(event) {
    let value = event.target.value;
    let type = event.target.dataset.type;

    if (value.length === 7 && value[0] === "#") {
      this.sendEvent("changeColor", {type: type, value: value});
    }
  }

  sendEvent(eventName, object) {
    theme_colors_embed_dark("themePreviewEvent", eventName, object);
    theme_colors_embed_light("themePreviewEvent", eventName, object);
  }
}
